import { render, staticRenderFns } from "./RightModel.vue?vue&type=template&id=93b4a058"
import script from "./RightModel.vue?vue&type=script&lang=js"
export * from "./RightModel.vue?vue&type=script&lang=js"
import style0 from "./RightModel.vue?vue&type=style&index=0&id=93b4a058&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports